export const habitImages = {
  defaultImage: 'assets/img/habits/default-habit-image.png',
  calendarGreen: 'assets/icons/habits/calendar-green.svg',
  man: 'assets/img/habits/man.svg'
};

export const starIcons = {
  whiteStar: 'assets/events-icons/star-empthy.svg',
  greenStar: 'assets/events-icons/star-filled.svg'
};
